import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, ListItemIcon, useTheme } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const Solutions: React.FC = () => {
  const theme = useTheme();
  
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      color: theme.palette.text.primary,
      padding: 4,
    }}>
      <Typography 
        variant="h2" 
        align="center" 
        sx={{ 
          mb: 1,
          fontWeight: 'bold',
          fontSize: { xs: '3rem', sm: '4rem', md: '5rem' },
        }}
      >
        Oppy: The Solution
      </Typography>
      <Typography 
        variant="h5" 
        align="center" 
        sx={{ 
          mb: 4, 
          fontStyle: 'italic',
          fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' },
          color: theme.palette.text.secondary,
        }}
      >
        The bottom line is top of mind.
      </Typography>
      <Box sx={{ maxWidth: '800px', margin: '0 auto' }}>
        <List>
          <ListItem>
            <ListItemIcon>
              <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main }} />
            </ListItemIcon>
            <ListItemText
              primary="Business phone + AI Employees in a few clicks"
              secondary="Legacy business phone systems simply come with a number. Oppy comes with a team of employees."
              primaryTypographyProps={{ 
                color: theme.palette.text.primary, 
                fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' },
                fontWeight: 'bold'
              }}
              secondaryTypographyProps={{ 
                color: theme.palette.text.secondary, 
                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
              }}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main }} />
            </ListItemIcon>
            <ListItemText 
              primary="Simple AI with Access to 60+ tools" 
              secondary="No code prompting for unlimited solutions in any vertical"
              primaryTypographyProps={{ 
                color: theme.palette.text.primary, 
                fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' },
                fontWeight: 'bold'
              }}
              secondaryTypographyProps={{ 
                color: theme.palette.text.secondary, 
                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
              }}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main }} />
            </ListItemIcon>
            <ListItemText 
              primary="24/7 AI-Powered Concierge" 
              secondary="Instant responses to inquiries, never miss an opportunity. "
              primaryTypographyProps={{ 
                color: theme.palette.text.primary, 
                fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' },
                fontWeight: 'bold'
              }}
              secondaryTypographyProps={{ 
                color: theme.palette.text.secondary, 
                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
              }}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main }} />
            </ListItemIcon>
            <ListItemText
              primary="Transaction Coordination"
              secondary="Automates reminders, scheduling, signatures, and checks, reducing TC workload"
              primaryTypographyProps={{ 
                color: theme.palette.text.primary, 
                fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' },
                fontWeight: 'bold'
              }}
              secondaryTypographyProps={{ 
                color: theme.palette.text.secondary, 
                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
              }}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main }} />
            </ListItemIcon>
            <ListItemText 
              primary="Multi-Channel Communication" 
              secondary="SMS, voice, email, and web chat options to cater to all preferences"
              primaryTypographyProps={{ 
                color: theme.palette.text.primary, 
                fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' },
                fontWeight: 'bold'
              }}
              secondaryTypographyProps={{ 
                color: theme.palette.text.secondary, 
                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
              }}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main }} />
            </ListItemIcon>
            <ListItemText 
              primary="Intelligent Lead Qualification" 
              secondary="Prioritize high-quality leads for agents, saving time and increasing efficiency"
              primaryTypographyProps={{ 
                color: theme.palette.text.primary, 
                fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' },
                fontWeight: 'bold'
              }}
              secondaryTypographyProps={{ 
                color: theme.palette.text.secondary, 
                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
              }}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main }} />
            </ListItemIcon>
            <ListItemText 
              primary="Automated Follow-ups" 
              secondary="Consistent nurturing of leads over time, increasing conversion rates"
              primaryTypographyProps={{ 
                color: theme.palette.text.primary, 
                fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' },
                fontWeight: 'bold'
              }}
              secondaryTypographyProps={{ 
                color: theme.palette.text.secondary, 
                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
              }}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main }} />
            </ListItemIcon>
            <ListItemText
              primary="Brokers, MLS, and Associations"
              secondary="Oppy is a turnkey solution for brokers, MLSs, and associations to offer a best-in-class customer experience to their clients & stakeholders."
              primaryTypographyProps={{ 
                color: theme.palette.text.primary, 
                fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' },
                fontWeight: 'bold'
              }}
              secondaryTypographyProps={{ 
                color: theme.palette.text.secondary, 
                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
              }}
            />
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};

export default Solutions;
